import React from 'react';
import ImageSearchOutlinedIcon from '@mui/icons-material/ImageSearchOutlined';
import { useTranslation } from 'react-i18next';
import UploadOutlinedIcon from '@mui/icons-material/UploadOutlined';
import { useDispatch } from 'react-redux';

import Icon from '../../../icons/Icon';
import CommonDropzone from '../../../components/common-dropzone/CommonDropzone';
import { setStudioCustomBucket } from '../../../redux/ai-studio/aiStudioActions';

import scss from './EmptyDisclaimer.module.scss';

function EmptyDisclaimer({ style, isVideoEnabled }) {
  const { t } = useTranslation('studio');
  const dispatch = useDispatch();

  const handleDrop = (files) => {
    dispatch(setStudioCustomBucket({ file: files[0] }));
  };

  const accept = {
    'image/jpeg': ['.jpeg', '.jpg'],
    'image/png': ['.png'],
    'image/webp': ['.webp'],
    ...(isVideoEnabled ? { 'video/mp4': ['.mp4', '.m4v', '.m4p'] } : {}),
  };

  return (
    <CommonDropzone
      onDrop={handleDrop}
      dropzoneProps={{
        accept: accept,
        multiple: false,
      }}
      style={style}>
      {() => (
        <div className={scss.emptyDisclaimer}>
          <ImageSearchOutlinedIcon className={scss.icon} />
          <span className={scss.label}>{t('emptyMediaSelector')}</span>
          <span className={scss.subLabel}>
            {t('emptyMediaSelectorDescription')}
            <Icon icon={UploadOutlinedIcon} className={scss.uploadIcon} disableCommonStyles disableCommonColors />
          </span>
        </div>
      )}
    </CommonDropzone>
  );
}

export default EmptyDisclaimer;
